var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "c--partner-with-us_airalo-affiliate-partners-have-to-say new-container mx-auto"
  }, [_c('div', {
    staticClass: "airalo-affiliate-partners-have-to-say my-20 my-md-30 my-lg-40"
  }, [_vm.title ? _c('h1', {
    staticClass: "have-to-say-title"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]) : _vm._e(), _vm._v(" "), false ? _c('div', {
    staticClass: "have-to-say-boxes"
  }, _vm._l(_vm.haveToSayItems, function (item, index) {
    return _c('div', {
      key: `have-to-say-boxes-item-${index}`,
      staticClass: "have-to-say-boxes-item"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": "",
        "width": "160",
        "height": "160",
        "loading": "lazy"
      }
    }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.companyName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.type))])]);
  }), 0) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "join-us-btn call-to-action dark no-outline btn-primary-hv tw-flex tw-justify-center tw-items-center hover:tw-no-underline",
    attrs: {
      "target": "_blank",
      "href": _vm.joinUsURL
    },
    on: {
      "click": function ($event) {
        return _vm.sendEventHandler(_vm.joinUsURL);
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('scenes.airalo.partner.hub.join-us-button-title')) + "\n    ")])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }